import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { makeLangUrl } from "helpers/makeLangUrl";

// Components
import Button from "components/atoms/Button";
import TournamentTimer from "components/atoms/TournamentTimer";

// Helpers
import { getImageSet } from "helpers/tournament";

// Hooks
import useFormatNumber from "hooks/useFormatNumber";
import useTranslate from "hooks/useTranslate";
import { useBreakpoint } from "hooks/useBreakpoint";

// Types
import { TournamentCardType } from "types/Tournament";

// Url
import url from "url/index";
import { useGTM } from "../../../hooks/useGTM";

import "./styles.sass";

type TournamentCardProps = {
  tournament: TournamentCardType;
  finished?: boolean;
};
const TournamentCard = (props: TournamentCardProps) => {
  const { tournament, finished } = props;
  // eslint-disable-next-line unused-imports/no-unused-vars
  const formatNumber = useFormatNumber();
  const t = useTranslate();
  const GTM = useGTM();
  const navigate = useNavigate();
  const { isTabletAndLess } = useBreakpoint();

  const imageSet = getImageSet(tournament.image, isTabletAndLess);

  const handleClick = () => {
    GTM.clickStartTournament(tournament);
    navigate(
      makeLangUrl(url.routes.tournament.tournamentId({ id: tournament.id })),
    );
  };

  const imageClass = classNames("TournamentCard__image", {
    finish: finished,
  });

  const titleClass = classNames("TournamentCard__title", {
    finish: finished,
  });

  const prizepoolClass = classNames("TournamentCard__prizepool", {
    finish: finished,
  });

  return (
    <div className="TournamentCard">
      <div className={imageClass}>
        <img src={imageSet} alt={tournament.header} />
      </div>

      <div className="TournamentCard__content">
        <div className={titleClass}>{tournament.header}</div>

        <div className={prizepoolClass}>
          € {tournament.totalPrizePool}
          <div className="TournamentCard__prizepool_title">
            {t("tournament.card.prize_fund")}
          </div>
        </div>

        <div className="TournamentCard__timer">
          <TournamentTimer finishDate={tournament.endDate} />
          {!finished && (
            <div className="TournamentCard__timer_title">
              {t("tournament.card.remaining")}
            </div>
          )}
        </div>

        {finished && (
          <div className="TournamentCard__over">
            {t("tournament.card.info.finished")}
          </div>
        )}

        {!finished && (
          <div className="TournamentCard__button">
            <Button
              variation="primary"
              label={t("tournament.card.participate")}
              onClick={handleClick}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TournamentCard;
